import React, { Component, PropTypes  } from 'react';
import { connect } from 'react-redux';
import Layout from 'components/componentKit2/Layout';
import { compose } from 'redux';
import * as R from 'ramda';
import * as ducks from './ducks';
import * as selectors from './selectors';
import classNames from 'classnames/bind';
import Spinner from 'components/componentKit2/Spinner';
import { render } from 'react-dom';
import { animateScroll as scroll, 	Events } from 'react-scroll'
import Strap from './components/Strap';
import cookie from 'react-cookie'

import {
	setMenuList,
} from 'actions';

import styles from './styles.css';

const cx = classNames.bind(styles);

const color = [
	'#cce5ff', '#d4edda', '#f8d7da', '#ffeeba', '#d1ecf1', '#ff980094', '#9c27b082', '#4caf50a8', '#e91e6385', '#3f51b59c'
]


const tabs = [
	{
		name: 'userRankList',
		label: 'Личное первенство',
		icon: 'user'
	},
	{
		name: 'workTeamRankList',
		label: 'Командный зачет',
		icon: 'userss'
	},
	{
		name: 'teamAdminRankList',
		label: 'Рейтинг лидеров',
		icon: 'star'
	}
];
const TAKE = 50;
let hide = false;

/**
 *  Контейнер Rating.
 *  Используется для отображения страницы реитинги (/ratings)
 *
 */
class Rating extends Component {
	/**
	 * @memberof RatingsPage
	 * @prop {object} propTypes - the props that are passed to this component
	 * @prop {func} propTypes.clearRenderChat Очистка чата
	 * @prop {func} propTypes.setMenuList установка выбранной старницы в меню
	 * @prop {func} propTypes.fetchTaskDayIfNeeded Получение данных для страницы дня
	 * @prop {object} propTypes.userInfo Данные пользователя
	 *
	 * */
	static propTypes = {

		/**
		 * Функция Очистка чата
		 * @memberof ChatPage
		 * @param {number} page - Номер выбранной страницы
		 */
		setMenuList: PropTypes.func.isRequired,
		/**
		 * Функция Очистка чата
		 * @memberof ChatPage
		 * @param {string} day - Номер дня.
		 */
		userInfo: PropTypes.object.isRequired,
	}

	componentDidMount() {
		const { dispatch, userList, location} = this.props;
		dispatch(setMenuList(7));

		if(location.pathname === '/ratings-hide'){
			hide = false;
		}

		Events.scrollEvent.register('begin', function () {

		});

		Events.scrollEvent.register('end', function () {

		});
		if(R.path(['data'], userList) && R.path(['data'], userList).length){
			return;
		}
		this.getUserRatings();

	}

	componentWillUnmount() {
		Events.scrollEvent.remove('begin');
		Events.scrollEvent.remove('end');
	}

	componentDidUpdate(prevProps){
		const {selectRating, userList} = this.props;
		if((prevProps.selectRating !== selectRating) && !R.path(['data'], userList).length){
			this.getUserRatings();
		}
	}

	scrollToTop = () => {
		scroll.scrollToTop();
	}


	getUserRatings = async (notScroll) => {
		const { dispatch, skip, selectRating, skipToSelf, search, userList, orderByField, orderByDirection } = this.props;
		const take = skipToSelf ? 10 : TAKE;

		const data = {
			skip,
			skipToSelf,
			take,
			rankListFilterText:search,
			orderByDirection: orderByDirection[orderByField],
			orderByField,
			season: cookie.load('currentSeason') ? cookie.load('currentSeason') : 0,
		};
		if(!skipToSelf){
			const newSkip = skip + take;
			await dispatch(ducks.setSkip({skip: newSkip, rating: selectRating}));
		} else {
			data.orderByField = '';
			data.orderByDirection = '';
			data.rankListFilterText = '';
			data.skip = 0;
		}
		await dispatch(ducks.getUserRankList({
			data,
			name: selectRating
		}));
		if(notScroll){
			return;
		}
		if(skipToSelf || (R.path(['data'], userList) && R.path(['data'], userList).length)){
			scroll.scrollToBottom();
		}
	}

	toggleTab = async (selectRating) => {
		const { dispatch, skipToSelf } = this.props;
		if(skipToSelf){
			await dispatch(ducks.setSkipToSelf(false));
		}
		await dispatch(ducks.setMode(''));
		await dispatch(ducks.setSearch(''));
		await dispatch(ducks.setRating(selectRating));
	}

	search = async () => {
		const {dispatch, selectRating} = this.props;
		await dispatch(ducks.resetList({rating:selectRating, searchStorage: true}));
		await dispatch(ducks.setSkip({skip: 0, rating: selectRating}));
		await dispatch(ducks.setSkipToSelf(false));
		await dispatch(ducks.setUnMerge(true));
		this.getUserRatings(true);
	}

	onChange= (e) => {
		const {dispatch} = this.props;
		dispatch(ducks.setSearch(e.target.value.trim()));
	}

	onKeyDownSearch = async (e) => {
		const {dispatch} = this.props;
		if (e.key === 'Enter') {
			await dispatch(ducks.setMode('search'));
			this.search()
		}
	}

	findMe = async () => {
		const {dispatch, selectRating} = this.props;
		await dispatch(ducks.setSkipToSelf(true));
		await dispatch(ducks.setRating('userRankList'));
		await dispatch(ducks.setSearch(''));
		await dispatch(ducks.resetList({rating:selectRating}));
		this.getUserRatings();
	}

	setPointsWidth = (selectRating) =>{
		let team = null;
		let city = null;
		let ava = null;
		if (selectRating === 'workTeamRankList'){
			team = '50%';
		}
		if (selectRating === 'teamAdminRankList'){
			city = '38%';
			ava = '33%';
		}
		return {team, city, ava};
	}

	renderTitleMobile = () => {
		const {selectRating} = this.props;
		let title= 'Личное первенство';

		if(selectRating === 'workTeamRankList'){
			title= 'Командный зачет';
		}
		if (selectRating === 'teamAdminRankList'){
			title= 'Рейтинг лидеров';
		}
		return title;
	}

	toggleSort = async (field) => {
		const {dispatch, selectRating, skipToSelf, mode} = this.props;
		if (skipToSelf) {
			return;
		}
		if (mode !== 'search') {
			await dispatch(ducks.resetList({rating:selectRating, storage:true}));
		}
		await dispatch(ducks.setUnMerge(true));
		await dispatch(ducks.setField(field));
		await dispatch(ducks.setSkip({skip: 0, rating: selectRating}));
		await dispatch(ducks.toggleDirection(field));
		this.getUserRatings(true);
	}

	renderBanner = () => {
		return (
			<div className={cx('banner')}>
				<h2>Поздравляем! Первые 4 недели подошли к концу!</h2>

				<p>У вас уже появились фавориты и любимчики? </p>
				<p>Посмотрим, кто действительно окажется на вершине Олимпа, а кто не дотянул до последнего пару шагов! </p>
				<p>Сейчас мы суммируем баллы за финальные экзамены, проверяем бизнес-баллы, а главное - щедро награждаем тех, кто достиг серьезных изменений “ДО / ПОСЛЕ”.</p>

				<h2>Ждите объявление итогов на Горячей Пятнице!</h2>
				<p>p.s. кстати, баллы за текущую активность уже идут в новый сезон! Поэтому не теряйте хватки - в борьбе за призы выигрывают упорные и внимательные</p>
			</div>
		)
	}

	render() {
		const { userInfo, userList, selectRating, search, skipToSelf, mode, location, orderByDirection } = this.props;

		const isEmpty = !R.path(['data', 'points'], userInfo);
		const prevSeasons = R.path(['data', 'prevSeasons'], userInfo);
		const  pointsWidth = this.setPointsWidth(selectRating);
		const straps = R.path(['data', 'userPointAchievementSeason'], userInfo);

		return (
			<Layout pageNumber={7} prevSeasons={prevSeasons} location={location}>
				{
					!isEmpty  ? !hide ?
						<div className={cx('rating')}>
							<div className={cx('rank')}>
								<div className={cx('rankItem')}>
									<div className={cx('card')}>
										<img  className={cx('cuboc')} src="/assets/img/els/cuboc.png" alt=""/>
										<div className={cx('top')}>
											<div className={cx('photo')} style={{background: !userInfo.data.photo && color[Number(String(userInfo.data.id).slice(-1))]}}>
												{
													userInfo.data.photo ?
													<img className={styles.photoImg} src={userInfo.data.photo} alt=""/>
														: <div className={cx('shortName')}>{`${userInfo.data.firstName.charAt(0)}${userInfo.data.lastName.charAt(0)}`}</div>
												}
											</div>
											<div className={cx('user')}>
												<div className={cx('userName')}>{`${userInfo.data.lastName} ${userInfo.data.firstName.charAt(0)}.`}</div>
												<div className={cx('blockInfo')}>
													<div className={cx('blockInfoText')}>
														<div className={cx('userStatusWrap')}>
															<div className={cx('infoText')}>звание:</div>
															<div className={cx('userStatus')}>{userInfo.data.points.pointAchievement.name}</div>
														</div>
														<div className={cx('userProgramWrap')}>
															<div className={cx('infoText')}>название программы:</div>
															<div className={cx('userProgram')}>{userInfo.data.programName}</div>
														</div>
													</div>
													<div className={cx('blockInfoStraps')}>
														{
															straps && straps.length ?
															straps.map((item) => {
																return (
																	<div className={cx('strap-wrap')}>
																		<Strap
																			key={item.season}
																			strap={item}
																			className={cx('strap-popup')}
																		/>
																	</div>
																)
															}) : null
														}
													</div>
												</div>
											</div>
										</div>

										<div className={cx('info')}>
											<div className={cx('infoBlock')}>
												<div className={cx('infoBlockItem')}>
													<div className={cx('infoText', 'place')}>место</div>
													<div className={cx('position', 'userPosition')}>{R.path(['data','points', 'userRank', 'common', 'position'], userInfo) || '-'}</div>
													<div className={styles.separator}>/</div>
													<div className={styles.text}>{R.path(['data','points', 'userRank', 'common', 'totalUsers'], userInfo) || '-'}</div>
												</div>
												<div className={cx('infoBlockItem')}>
													<div className={styles.infoText}>баллов</div>
													<div className={cx('position', 'userPoints')}>{R.path(['data','points', 'userRank', 'common', 'points'], userInfo) || '-'}</div>
												</div>
											</div>

											<div className={styles.report}>
												<div className={styles.reportTitle}>Спортивный зачет:</div>
												<div className={styles.points}>
													<div className={cx('position', 'userSport')}>{R.path(['data','points', 'userRank', 'sport', 'position'], userInfo) || '-'}</div>
													<div className={styles.reportText}>место</div>
												</div>

												<div className={styles.points}>
													<div className={cx('position', 'sportPoints')}>{R.path(['data','points', 'userRank', 'sport', 'points'], userInfo) || '-'}</div>
													<div className={styles.reportText}>баллов</div>
												</div>
											</div>

											<div className={styles.report}>
												<div className={styles.reportTitle}>Бизнес зачет:</div>
												<div className={styles.points}>
													<div className={cx('position', 'userSport')}>{R.path(['data','points', 'userRank', 'business', 'position'], userInfo) || '-'}</div>
													<div className={styles.reportText}>место</div>
												</div>
												<div className={styles.points}>
													<div className={cx('position', 'sportPoints')}>{R.path(['data','points', 'userRank', 'business', 'points'], userInfo) || '-'}</div>
													<div className={styles.reportText}>баллов</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className={cx('rankItem')}>
									<div className={cx('card')}>
										<div className={cx('top')}>
											<div className={cx('photo', 'photoTeam')} style={{background: color[2]}}>
												{/*<img className={styles.photoTeamImg} src='/assets/img/els/users.png' alt=""/>*/}

												<div className={cx('shortName')}>{R.path(['data','customUserFields', 'workTeam'], userInfo) ? R.path(['data','customUserFields', 'workTeam'], userInfo).slice(0, 2) : null}</div>

											</div>
											<div className={cx('user', 'userTeam')}>
												<div className={cx('userTeam')}>{R.path(['data','customUserFields', 'workTeam'], userInfo) || '-'}</div>
											</div>
										</div>
										<div className={cx('info')}>
											<div className={cx('infoBlock')}>
												<div className={cx('infoBlockItem')}>
													<div className={cx('infoText', 'place')}>место</div>
													<span className={cx('position', 'userPosition')}>{R.path(['data','points', 'teamRank', 'common', 'position'], userInfo) || '-'}</span>
													<span className={styles.separator}>/</span>
													<span className={styles.text}>{R.path(['data','points', 'teamRank', 'common', 'totalUsers'], userInfo) || '-'}</span>
												</div>
												<div className={cx('infoBlockItem')}>
													<div className={styles.infoText}>баллов</div>
													<div className={cx('position', 'userPoints')}>{R.path(['data','points', 'teamRank', 'common', 'points'], userInfo) || '-'}</div>
												</div>
											</div>

											<div className={styles.report}>
												<div className={styles.reportTitle}>Спортивный зачет:</div>
												<div className={styles.points}>
													<div className={cx('position', 'userSport')}>{R.path(['data','points', 'teamRank', 'sport', 'position'], userInfo) || '-'}</div>
													<div className={styles.reportText}>место</div>
												</div>

												<div className={styles.points}>
													<div className={cx('position', 'sportPoints')}>{R.path(['data','points', 'teamRank', 'sport', 'points'], userInfo) || '-'}</div>
													<div className={styles.reportText}>баллов</div>
												</div>
											</div>

											<div className={styles.report}>
												<div className={styles.reportTitle}>Бизнес зачет:</div>
												<div className={styles.points}>
													<div className={cx('position', 'userSport')}>{R.path(['data','points', 'teamRank', 'business', 'position'], userInfo) || '-'}</div>
													<div className={styles.reportText}>место</div>
												</div>

												<div className={styles.points}>
													<div className={cx('position', 'sportPoints')}>{R.path(['data','points', 'teamRank', 'business', 'points'], userInfo) || '-'}</div>
													<div className={styles.reportText}>баллов</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div className={styles.tabNav}>
								<div className={styles.tabNavList}>
									{
										tabs.map((tab) => {
											return (
												<div
													key={tab.name}
													className={classNames(styles.tabNavItemWrap, {
														[styles.active]: tab.name === selectRating && !skipToSelf && mode !== 'search',
													})}
													onClick={() => this.toggleTab(tab.name)}
												>
													<div className={classNames(styles.iconWrap, {
														[styles.active]: tab.name === selectRating && !skipToSelf && mode !== 'search',
													})}>
														<svg className={cx(`i-${tab.icon}`, 'icon-menu')}>
															<use xlinkHref={`#${tab.icon}`}/>
														</svg>
														<div className={classNames(styles.iconWrapPoint, {
															[styles.active]: tab.name === selectRating && !skipToSelf && mode !== 'search',
														})} />
													</div>
													<div
														className={classNames(styles.tabNavItem,{
															[styles.active]: tab.name === selectRating && !skipToSelf && mode !== 'search',
														})}
													>
														{tab.label}
													</div>
												</div>
											)
										})
									}
								</div>

								<div className={styles.mobileTitle}>
									{this.renderTitleMobile()}
								</div>

								<div className={styles.myPosition} onClick={this.findMe}>
									<svg className={cx('i-crosshair')}>
										<use xlinkHref='#crosshair'/>
									</svg>
									<div>
										Мое положение
									</div>
								</div>

								<div className={styles.search}>
									<svg className={cx('i-search')}>
										<use xlinkHref='#search'/>
									</svg>
									<input
										type="text"
										name='search'
										value={search}
										placeholder={'Поиск'}
										onChange={this.onChange}
										className={styles.searchInput}
										onKeyDown={this.onKeyDownSearch}
									/>
								</div>

							</div>
              <div className={cx('table')}>
							<div className={cx('tabContent')}>
									<div className={cx('head')}>
										<div className={cx('item', 'place-t')} onClick={() => this.toggleSort('position')}>
											<span
												className={cx('itemValue', orderByDirection.position, {
													[styles.active]: orderByDirection.position,
												})}>
													Место
											</span>
										</div>
										{ selectRating !== 'workTeamRankList' &&
										<div
											style={pointsWidth.ava && {width: pointsWidth.ava}}
											className={cx('item', 'ava-t')}
											onClick={() => this.toggleSort('lastName')}
										>
											<span
												className={cx('itemValue', orderByDirection.lastName, {
													[styles.active]: orderByDirection.lastName,
												})}>
													Герой
											</span>
										</div>}
										{ selectRating !== 'teamAdminRankList' &&
										<div
											style={pointsWidth.team && {width: pointsWidth.team}}
											className={cx('item', 'team-t')}
											onClick={() => this.toggleSort('workTeamName')}
										>

											<span
												className={cx('itemValue', orderByDirection.workTeamName,{
													[styles.active]: orderByDirection.workTeamName,
												})}>
												Команда
											</span>
										</div>}
										{ selectRating !== 'workTeamRankList' &&
										<div
											style={pointsWidth.city && {width: pointsWidth.city}}
											className={cx('item', 'city-t')}
											onClick={()=> this.toggleSort('city')}
										>
											<span
												className={cx('itemValue', orderByDirection.city, {
												[styles.active]: orderByDirection.city,
											})}>Город</span>
										</div> }
										{ selectRating === 'workTeamRankList' &&
										<div className={cx('item', 'total-t')} onClick={() => this.toggleSort('totalUsers')}>
											<span
												className={cx('itemValue', orderByDirection.totalUsers, {
													[styles.active]: orderByDirection.totalUsers,
												})}>
												Количество человек
											</span>

										</div>}
										<div  className={cx('item', 'itemPoints')} onClick={() => this.toggleSort('sportPoints')}>
											<div>
												<div className={cx('itemValue', 'points', 'sport')}>Спорт</div><div>(баллы)</div>
											</div>
										</div>
										<div  className={cx('item', 'itemPoints')} onClick={() => this.toggleSort('businessPoints')}>
											<div>
												<div className={cx('itemValue', 'points')}>Бизнес</div>
												<div>(баллы)</div>
											</div>
										</div>
										<div  className={cx('item', 'itemPoints')} onClick={() => this.toggleSort('commonPoints')}>
											<div>
												<div className={cx('itemValue', 'points')}>Общий</div><div>(баллы)</div>
											</div>
										</div>
									</div>
									{
										R.path(['isError'], userList) ?
											<div className={cx('error')}>{R.path(['errMsg'], userList)}</div> :
											<div>
												<div className={cx('content')}>
													{
														R.path(['data'], userList) ? R.path(['data'], userList).length ? userList.data.map((user) => {
															const isSelect = userInfo.data.id === user.id && skipToSelf;
															if(user.divisionTitle){
																return <div className={cx('division-title')}>{user.divisionTitle}</div>
															}
															return (
																<div
																	className={classNames(styles.line, {
																		[styles.isSelect]: isSelect,
																	})}
																  key={user.id}
																>
																	<div className={cx('item', 'place-t')}>{user.position || '-'}</div>

																	{ selectRating !== 'workTeamRankList' && <div style={pointsWidth.ava && {width: pointsWidth.ava}} className={cx('item', 'ava-t')}>
																		<div className={cx('ava')}  style={{background: !user.photo && color[Number(String(user.id).slice(-1))]}}>
																			{
																				user.photo ? <img src={user.photo} alt=""/> : <div className={cx('shortName-small')} >{`${user.firstName.charAt(0)}${user.lastName.charAt(0)}`}</div>
																			}
																		</div>

																	  <div  className={cx('hero-info')}>
																			<div className={cx('hero-name')}>{`${user.lastName} ${user.firstName.charAt(0)}.`}</div>
																			{user.pointAchievement && <div className={cx('description')}>

																				<svg className={cx('flag')} width={'15px'} height={'15px'}>
																					<use xlinkHref={`#medals-${user.pointAchievement.id}`}/>
																				</svg>
																			 <div 	className={cx('achievement')}>{user.pointAchievement.name || '-'}</div>
																			</div>}
																		</div>
																	</div>
																	}
																	{ selectRating !== 'teamAdminRankList' &&	<div style={pointsWidth.team && {width: pointsWidth.team}} className={cx('item', 'team-t')}>{user.workTeamName || '-'}</div>}
																	{ selectRating !== 'workTeamRankList' && <div style={pointsWidth.city && {width: pointsWidth.city}} className={cx('item', 'city-t')}>{user.city || '-'}</div>}
																	{ selectRating === 'workTeamRankList' && <div className={cx('item', 'total-t')}>{user.totalUsers || '-'}</div>}
																	<div  className={cx('item', 'itemPoints')}>{user.sportPoints || '-'}</div>
																	<div  className={cx('item','itemPoints')}>{user.businessPoints || '-'}</div>
																	<div  className={cx('item', 'itemPoints')}>{user.commonPoints || '-'}</div>
																</div>
															)
														}) : R.path(['isFetching'], userList) ? null : <div className={cx('empty')}>нет данных</div> : null
													}
												</div>
											</div>
									}

								</div>
						 </div>
							<div  className={cx('bottom')}  ref={el => this.bottom= el} >
								{
									R.path(['isFetching'], userList) ?
										<div><Spinner /></div> :
										R.path(['isError'], userList)? null : R.path(['showMore'], userList)?
											<div className={cx('btn-link')} onClick={this.getUserRatings}>Показать еще</div>
											: null
								}
							</div>
						</div>
					: this.renderBanner(): null
				}
			</Layout>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		userList: selectors.userList(state),
		userInfo: selectors.userInfo(state),
		selectRating: selectors.selectRating(state),
		skipToSelf: selectors.skipToSelf(state),
		skip: selectors.skip(state),
		userSelf: selectors.userSelf(state),
		search: selectors.search(state),
		mode: selectors.mode(state),
		orderByDirection: selectors.orderByDirection(state),
		orderByField: selectors.orderByField(state),
		count: selectors.count(state),
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		dispatch,
	};
};

export default compose(
	connect(mapStateToProps, mapDispatchToProps),
)(Rating);


// WEBPACK FOOTER //
// /var/www/build-health-2/src/modules/Rating/main.js